import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link, useParams } from 'react-router-dom';
import useMount from '../../../../../common/hooks/useMount';
import Loader from '../../../../../common/widgets/Loader';
import { HelpMenuItemModel } from '../../../models/Help';
import { helpService } from '../../../services/help';

interface HelpMenuState {
  items?: HelpMenuItemModel[];
  showErrorPanel?: boolean;
}

export const HelpMenu = () => {
  const [state, setState] = useState<HelpMenuState>({});

  const loadMenuItems = async (abortController?: AbortController) => {
    const resp = await helpService.getHelpMenu({
      signal: abortController?.signal,
    });
    if (!resp.hasErrors) {
      setState({ items: resp.data });
    } else {
      if (!abortController?.signal.aborted) {
        setState({ showErrorPanel: true });
      }
    }
  };

  useMount(loadMenuItems);

  return (
    <Loader
      loading={!state.items}
      loader={<Skeleton />}
      showErrorPanel={state.showErrorPanel}
    >
      <ul>
        {state.items?.map(e => <HelpMenuItem key={e.sectionId} {...e} />)}
      </ul>
    </Loader>
  );
};

interface HelpMenuItemProps extends HelpMenuItemModel {}

const HelpMenuItem = (props: HelpMenuItemProps) => {
  const { sectionId, name } = props;
  const { sectionId: paramsSectionId } = useParams();

  const isActive =
    !!paramsSectionId && sectionId === Number.parseInt(paramsSectionId);

  return (
    <li className={isActive ? 'active' : ''}>
      <Link to={`/help/sections/${sectionId}`}>{name}</Link>
    </li>
  );
};
